<div class="parentcard border rounded overflow-y-auto">
  <!-- Updated header section -->
  <div class="page-header">
    <div class="d-flex justify-content-between align-items-center">
      <h4>
        <i class="bi bi-database me-2"></i>
        Available Databases
      </h4>
      <button class="btn btn-primary addbtn" (click)="openAddDatabaseModal()">
        <i class="bi bi-plus-lg"></i> Add Database
      </button>
    </div>
  </div>

  <div class="database-list">
    <!-- <hr> -->
    <div class="card-container" *ngIf="databases.length > 0">
      <div class="card" *ngFor="let database of databases">
        <div class="card-header d-flex justify-content-between align-item-center">
          <div class="d-flex align-items-center gap-4">
            <img
            class="database-logo"
            [src]="getDatabaseLogo(database.platform_type)"
            alt="{{ database.platform_name }}"
          />
          <h6>{{ getPlatformDisplayName(database.platform_type) }}</h6>
          </div>
          <div class="d-flex gap-2">
            <button class="btn btn-link text-primary border" (click)="openEditModal(database)">
              <i class="bi bi-pencil"></i>
            </button>
            <button class="btn btn-link text-danger border" (click)="openDeleteModal(database.platform_name)">
              <i class="bi bi-trash"></i>
            </button>

          </div>

        </div>
        <div class="card-body">
          <div class="row">
            <p><b> Database Name: </b>{{ database.platform_name }}</p>
            <p><b> Owner: </b>{{ database.connection_details.username }}</p>
            <div *ngIf="database.platform_type === 'snowflake'" class="snowflake-fiels">
              <p><b> Role: </b>{{ database.connection_details.role }}</p>
              <p><b> Warehouse: </b>{{ database.connection_details.warehouse }}</p>
            </div>
            <div *ngIf="database.platform_type === 'mysql'" class="mysql-fiels">
              <p><b> Port: </b>{{ database.connection_details.port || '3306' }}</p>
              <p><b> Database: </b>{{ database.connection_details.database }}</p>
            </div>
            <div *ngIf="database.platform_type === 'postgres'" class="postgres-fiels">
              <p><b> Post: </b>{{ database.connection_details.port || '5432' }}</p>
              <p><b> Database: </b>{{ database.connection_details.database }}</p>
            </div>


          </div>

          <div class="status-container">
            <div class="row" style="width: 100%; margin-left: auto; margin-right: auto;">
              <button
                class="btn btn-secondary btn-block"
                [ngClass]="{ 'btn-success': database.status === true, 'btn-danger': database.status === false }"
                (click)="testConnection(database)"
              >
                {{
                  database.status == null ? 'Test Connection' :
                  database.status ? 'Test Successful' : 'Test Failed'
                }}
              </button>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
  <div
  class="toast-container position-fixed top-0 end-0 p-3"
  style="z-index: 1100"
>
  <ngb-toast
    *ngFor="let toast of toastService.getToasts()"
    [autohide]="toast.options?.autohide ?? true"
    [delay]="toast.options?.delay ?? 5000"
    [class]="toast.options?.classname"
    (hidden)="toastService.remove(toast)"
  >
    <ng-template [ngIf]="toastService.isTemplate(toast)" [ngIfElse]="text">
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    </ng-template>
    <ng-template #text>{{ toast.textOrTpl }}</ng-template>
  </ngb-toast>
</div>
</div>
